import { z } from 'zod';

/** Проверяет выбранный заказ для привязки сделки */
export const taskBindingSchema = z.object({
    orderId: z.string()
        .uuid('Выберите заказ без сделки'),
});

export type TaskBindingFormValues = z.infer<typeof taskBindingSchema>;

export const TASK_BINDING_FORM_DEFAULTS: TaskBindingFormValues = {
    orderId: '',
};

/** Проверяет точный номер либо идентификатор искомого заказа */
export const taskOrderSearchSchema = z.discriminatedUnion('mode', [
    z.object({
        mode: z.literal('number'),
        query: z.string()
            .trim()
            .regex(/^[1-9]\d*$/)
            .refine((value) => Number.isSafeInteger(Number(value))),
    }),
    z.object({
        mode: z.literal('id'),
        query: z.string()
            .trim()
            .uuid(),
    }),
]);

export type TaskOrderSearchValues = z.infer<typeof taskOrderSearchSchema>;

/** Проверяет номер задания для поиска сделки */
export const taskSearchSchema = z.object({
    taskId: z.number({ message: 'Укажите номер задания' })
        .int('Укажите целый номер задания')
        .positive('Номер задания должен быть больше нуля')
        .nullable()
        .refine((value) => value !== null, 'Укажите номер задания'),
});

export type TaskSearchFormValues = z.input<typeof taskSearchSchema>;

export type TaskSearchSubmittedValues = z.output<typeof taskSearchSchema>;

export const TASK_SEARCH_FORM_DEFAULTS: TaskSearchFormValues = {
    taskId: null,
};

/** Проверяет комментарий к действию над сделкой */
export const taskActionSchema = z.object({
    comment: z.string()
        .trim(),
});

export type TaskActionFormValues = z.infer<typeof taskActionSchema>;

export const TASK_ACTION_FORM_DEFAULTS: TaskActionFormValues = {
    comment: '',
};
